import React from "react";
import PropTypes from "prop-types";
import {
	ConfirmCard,
	ConfirmCardContainer,
	WalletBtns,
	WalletContainer,
	WalletHeader,
} from "../walletStyles";
import { getFormattedAmount } from "../../../utils/AmountUtils";

const ConfirmWithdrawal = ({
	onClose,
	fee,
	amount,
	description,
	total,
	whiteBtnClick,
	greenBtnClick,
	balance,
	bankInfo,
}) => {
	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText='Confirm Transaction'
					onCloseModal={onClose}
					context='Account Balance: '
					amount={getFormattedAmount.format(balance)}
					color={balance > 100 ? "green" : "red"}
				/>
				<ConfirmCardContainer>
					<ConfirmCard
						textOne='From'
						textTwo='Transaction Fee'
						textThree='Wallet Balance'
						textFour={getFormattedAmount.format(fee || 0)}
					/>
					<ConfirmCard
						textOne='To'
						textTwo='Amount'
						textThree={bankInfo?.accountName}
						textFour={getFormattedAmount.format(amount || 0)}
					/>
					<ConfirmCard
						textOne='Bank Name'
						textTwo='Account Number'
						textThree={bankInfo?.bankName}
						textFour={bankInfo?.accountNumber}
					/>
					<ConfirmCard
						textOne='Description'
						textTwo='Total'
						textThree={description}
						textFour={getFormattedAmount.format(total || 0)}
					/>
				</ConfirmCardContainer>
				<WalletBtns btnText='confirm' whiteBtnClick={whiteBtnClick} greenBtnClick={greenBtnClick} />
			</>
		</WalletContainer>
	);
};

ConfirmWithdrawal.propTypes = {
	onClose: PropTypes.func,
	fee: PropTypes.number,
	amount: PropTypes.number,
	description: PropTypes.string,
	total: PropTypes.number,
	whiteBtnClick: PropTypes.func,
	greenBtnClick: PropTypes.func,
	balance: PropTypes.number,
	bankInfo: PropTypes.object,
};

export default ConfirmWithdrawal;
